module.exports = __webpack_public_path__ + "st.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/st.svg
// module id = 819
// module chunks = 0